import React, { useState, useCallback } from "react";
import { Modal, Form, Row, Col, Select, message } from "antd";
import { ShipmentStatus } from "@/typedefs/shipment";
import { STATUS } from "@/utils/enum";
import { Validator } from "@/utils/validator";
import { duplicateShipment } from "@/services/shipments_new";
const { Option } = Select;
const DuplicateShipmentModal = ({ open, shipmentId, shipmentStatus, onClose }) => {
    const [form] = Form.useForm();
    const [status, setStatus] = useState(STATUS.IDLE);
    const closeAndReset = useCallback(() => {
        setStatus(STATUS.IDLE);
        form.resetFields();
        onClose?.();
    }, [form, onClose]);
    const handleOnFinish = useCallback((values) => {
        setStatus(STATUS.LOADING);
        duplicateShipment({
            shipmentId,
            copyVehicles: values.copyVehicles,
        })
            .then(newShipmentId => {
            window.open(`/admin/shipments/view?shipmentId=${newShipmentId}`, "_blank");
            message.success("Shipment duplicated successfully");
            closeAndReset();
        })
            .catch(error => {
            setStatus(STATUS.ERROR);
            console.error(error);
        })
            .finally(() => {
            setStatus(STATUS.IDLE);
        });
    }, [shipmentId, closeAndReset]);
    const finishFromOkButton = useCallback(() => {
        form.submit();
    }, [form]);
    return (React.createElement(Modal, { title: "Duplicate Shipment", open: open, okText: "Confirm", onOk: finishFromOkButton, onCancel: closeAndReset, confirmLoading: status === STATUS.LOADING },
        React.createElement(Form, { form: form, initialValues: { copyVehicles: false }, onFinish: handleOnFinish },
            React.createElement(Row, { gutter: 16 },
                React.createElement(Col, { flex: 1 },
                    React.createElement(Form.Item, { name: "copyVehicles", label: "Copy Vehicles", rules: [Validator.required("Please select an option")] },
                        React.createElement(Select, { placeholder: "Copy Vehicles" },
                            React.createElement(Option, { value: false }, "Duplicate without vehicles"),
                            React.createElement(Option, { value: true, disabled: shipmentStatus >= ShipmentStatus.Posted }, "Duplicate with vehicles"))))))));
};
export default DuplicateShipmentModal;
